<template>
    <div class="tab-pane active">
        <div class="modal_content p-15">
            <PmlForm></PmlForm>
        </div>
        <div class="table-responsive">
            <table class="table table-striped table-bordered m-0">
                <thead>
                    <tr>
                        <th class="th_sort" @click.prevent="setOrder('type')" :class="isOrderedColumn('type')">{{ $t('type') }}</th>
                        <th class="th_sort" @click.prevent="setOrder('description')" :class="isOrderedColumn('description')">{{ $t('description') }}</th>
                        <th class="t_right">{{ $t('value') }}</th>
                        <th class="t_center w_100">{{ $t('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <PmlItem v-for="item in list" :key="item.id" :item="item"></PmlItem>
                    <tr v-show="!list.length">
                        <td class="t_center" colspan="6"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import PmlForm from './Form.vue'
    import PmlItem from './Item.vue'
    import TableFilters from 'utils/mixins/table-filters'
    import { mapGetters } from 'vuex'

    export default {
        name: 'QuotationCharge',
        mixins: [ TableFilters ],
        components: { PmlItem, PmlForm },
        data () {
            return {
                listConfig: {
                    orderProp: 'type',
                    orderDir: 'asc'
                }
            }
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'deal': 'getDealInfo',
                'quotations': 'getDealQuotations'
            }),
            quotation () {
                return this.quotations.find((item) => item.id === parseInt(this.$route.params.quotation)) || {}
            },
            records () {
                return this.quotation.charges || []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/charges/Main.vue